import React, { useState, useEffect } from 'react';
import { InputType } from 'reactstrap/es/Input';
import NSInput from '../NSInput/NSInput';

export interface INSProFormaInputProps {
    name: string;
    type?: InputType;
    value?: string | number | null;
    handleUpdateValue: (updatedValue: string | number) => void;
    placeholder?: string;
    disabled?: boolean;
    min?: number | string;
    max?: number | string;
    appendInputAddon?: string | JSX.Element;
    inputGroupClassName?: string;
    customClassName?: string;
    step?: number;
}

const NSProFormaInput = ({
    name,
    type = 'text',
    value = null,
    handleUpdateValue,
    placeholder = '',
    disabled = false,
    min,
    max,
    appendInputAddon,
    inputGroupClassName,
    customClassName,
    step,
}: INSProFormaInputProps) => {
    const [inputValue, setInputValue] = useState<string>(String(value ?? ''));
    const [forceBlur, setForceBlur] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (forceBlur) {
            setTimeout(() => {
                setForceBlur(false);
            }, 1000);
        }
    }, [forceBlur]);

    useEffect(() => {
        if (!isFocused) {
            setInputValue(String(value ?? ''));
        }
    }, [value, isFocused]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
    };

    const handleBlur = () => {
        const currentValue = inputValue;
        const trimmedValue = typeof currentValue === 'string' ? currentValue.trim() : currentValue;
        const valueToCompare = String(value ?? '');

        if (trimmedValue !== valueToCompare) {
            if (type === 'number') {
                handleUpdateValue(Number(trimmedValue) || 0);
            } else {
                handleUpdateValue(trimmedValue);
            }
        }
        setIsFocused(false);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            const trimmedValue = typeof inputValue === 'string' ? inputValue.trim() : inputValue;
            if (type === 'number') {
                handleUpdateValue(Number(trimmedValue) || 0);
            } else {
                handleUpdateValue(trimmedValue);
            }
            setForceBlur(true);
        } else if (event.key === 'Escape') {
            setInputValue(String(value ?? ''));
            setForceBlur(true);
        }
    };

    return (
        <NSInput
            name={name}
            type={type}
            value={inputValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onFocus={() => setIsFocused(true)}
            placeholder={placeholder}
            disabled={disabled || forceBlur}
            min={min}
            max={max}
            appendInputAddon={appendInputAddon}
            inputGroupClassName={inputGroupClassName}
            customClassName={customClassName}
            step={step}
        />
    );
};

export default NSProFormaInput;
